import { Role } from "../models/role.model";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

export default {
  getRoles() {
    return axios.get().get<ApiResponse<Role[]>>("/roles");
  }
};
